// extracted by mini-css-extract-plugin
export default {"badges":"Badge_badges__6LWhG"};